import { Fragment } from 'react'
import { Note } from '../../ui'
import { warningNotes, type DryWarning, type WarnCtx } from './groupAdmin'
import { tn } from './nodeSwitch'

/**
 * The warnings of a dry run, first in a confirmation (NG-18 C): one `.sx-note` warn each, a bold
 * first sentence and what it means. They warn and never block (owner V2, V3).
 */
export function WarningNotes({ warnings, ctx, testId = 'dry-warnings' }: { warnings: DryWarning[]; ctx: WarnCtx; testId?: string }) {
  if (!warnings.length) return null
  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      {warnings.flatMap((w, i) =>
        warningNotes(w, ctx).map((x, j) => (
          <Note key={`${w.code}-${i}-${j}`} state="warn" data-testid={`${testId}-${w.code}`}>
            <b className="font-medium text-text">{tn(...x.title)}</b>
            {x.body && <> {tn(...x.body)}</>}
            {x.after?.map((a, k) => <Fragment key={k}> {tn(...a)}</Fragment>)}
            {x.raw && <> {x.raw}</>}
          </Note>
        )),
      )}
    </div>
  )
}
